import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';

export const icons = [faCircleInfo];
